import type { ListBoardItemResponse, ListBoardsResponse } from "@/client";

export type BoardListCacheEntry = Pick<ListBoardItemResponse, "id" | "title">;

export function upsertBoardInListResponse(
	list: ListBoardsResponse | undefined,
	board: BoardListCacheEntry,
): ListBoardsResponse {
	const existingBoards = list?.boards ?? [];
	const withoutBoard = existingBoards.filter((item) => item.id !== board.id);

	return {
		...list,
		boards: [board, ...withoutBoard],
		total: withoutBoard.length + 1,
	};
}
